// R3-15 = B: in Reports a CSAT rating is its name only ("Excelente"), with no emoji. The woot's CSAT.RATINGS carries
// the emoji in the text ("😍 Excelente") and stays as it is for the conversation's CSAT bubble and the survey.
export const csatRatingNames = t => ({
  1: t('POLARIS_REPORTS.RATING_NAMES.POOR'),
  2: t('POLARIS_REPORTS.RATING_NAMES.FAIR'),
  3: t('POLARIS_REPORTS.RATING_NAMES.AVERAGE'),
  4: t('POLARIS_REPORTS.RATING_NAMES.GOOD'),
  5: t('POLARIS_REPORTS.RATING_NAMES.EXCELLENT'),
});
